import styled from 'styled-components';

export const Signature = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;

	@media only screen and (min-width: 601px) {
		background-color: #F5F5F5;
	}

	@media only screen and (max-width: 600px) {
		background-color: white;
	}
`;

Signature.Container = styled.div`
	padding: 16px;

	@media only screen and (min-width: 601px) {
		max-width: 600px;
		background-color: white;
		margin: 2rem auto;
		padding: 32px;
		border-radius: 16px;
	}
`;

Signature.Title = styled.span`
	font-weight: 600;
	font-size: 18px;
	color: #26282A;
`;

Signature.FooterContainer = styled.div`
	position: fixed;
	bottom: 0;
`;
